module.exports = __webpack_public_path__ + "static/media/0602.300062aa.png";